import script from "./data_format_rules.vue?vue&type=script&setup=true&lang=js"
export * from "./data_format_rules.vue?vue&type=script&setup=true&lang=js"

import "./data_format_rules.vue?vue&type=style&index=0&id=50cbefe2&lang=scss"

const __exports__ = script;

export default __exports__